import { useState } from 'react';
import './CourseFaq.scss';
import { useMobile } from '@helpers/hooks';
import icons from '@assets/icons/redesign';
import { cn } from '@helpers/styles';

const { ArrowUp, ArrowDown } = icons;

export default function CourseFaq({ items }) {
  const [isMobile] = useMobile();
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    const isSame = index === openIndex;
    const nextIndex = isSame ? null : index;

    setOpenIndex(nextIndex);

    if (!isSame) {
      setTimeout(() => {
        const item = document.querySelectorAll('.courseFaq-item')[index];
        if (!item) return;

        const offset = isMobile ? 100 : 60;
        const top = item.getBoundingClientRect().top + window.scrollY - offset;

        window.scrollTo({ top, behavior: 'smooth' });
      }, 100);
    }
  };

  return (
    <section className="courseFaq">
      <div className="courseFaq-content">
        <h2 className="courseFaq-title">Veelgestelde vragen</h2>

        {items.map((item, idx) => {
          const isOpen = openIndex === idx;

          return (
            <div
              key={idx}
              className={cn('courseFaq-item', {
                'courseFaq-item-open': isOpen
              })}
              onClick={() => toggle(idx)}
            >
              <div className="courseFaq-question-row">
                <h3 className="courseFaq-question">{item.question}</h3>
                {isOpen ? (
                  <ArrowUp className="courseFaq-question-row-icon" />
                ) : (
                  <ArrowDown className="courseFaq-question-row-icon" />
                )}
              </div>

              <div
                className="courseFaq-answer"
                dangerouslySetInnerHTML={{ __html: item.answer }}
              />
            </div>
          );
        })}
      </div>
    </section>
  );
}
